// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"c77efeb5a1577fe581e5","655":"191cd26f38de03880076"}[chunkId] + ".js";
};